import { Container } from "@brightagency/headstart-common";
import React, { ReactNode } from "react";
import { WPImage, WPPost } from "../../../constants/types";
import { useCurrentRouteData } from "../../../services/app-state";
import { SaveItemButton } from "../../atoms/SaveItemButton";
import { Outer, Inner, Title, SaveWrapper } from "./styled";

interface Props {
    title: ReactNode;
    image?: WPImage;
}

export const HeroPostTypePage: React.FC<Props> = props => {
    const { id } = useCurrentRouteData<WPPost>();

    return (
        <Outer>
            <Container>
                <Inner>
                    <Title>{props.title}</Title>
                    <SaveWrapper>
                        <SaveItemButton id={id} size="large" />
                    </SaveWrapper>
                </Inner>
            </Container>
        </Outer>
    );
};
